export default "__VITE_ASSET__gXmHz54$__"